import { useQuery } from '@tanstack/react-query'
import { api } from '~/apiClient'

async function fetchUserLevelingProgression() {
    return api.get<UserLevelingProgression>('/api/progression/user/leveling/')
}

export const useUserLevelingProgressionQuery = () => {
    return useQuery({
        queryKey: ['progression', 'user', 'leveling'],
        queryFn: () => fetchUserLevelingProgression(),
        initialData: {
            level: 0,
            level_progress: 0,
            current_exp: 0,
            next_level_exp: 0,
            next_level_rewards: [],
        },
    })
}
